import { Requester } from './Requester';
import { ILoanRecord, TableQueryParams } from '../types';

export const GetLoans = async (
    options: TableQueryParams
): Promise<{ loans: ILoanRecord[]; totalRecords: number } | null> => {
    try {
        const response = await Requester<{
            loans: ILoanRecord[];
            totalRecords: number;
        }>({
            // port: '8080',
            path: 'loans/paged',
            method: 'PUT',
            payload: options
        });

        if ('loans' in response && Array.isArray(response.loans)) return response;
        return null;
    } catch (e) {
        console.error('Get orgs request failed');
        return Promise.reject(e);
    }
};
